import React from "react";
import { shape, func, bool, string } from "prop-types";
import { Link } from "@quintype/components";

const MenuItem = ({ item, itemClick, target }) => {
  const { "item-type": type, title = "", "menu-group-slug": menuGroupSlug, completeUrl } = item;
  if (type === "placeholder") {
    return <span>{title}</span>;
  } else if (type === "link" && menuGroupSlug !== "prothomalo") {
    return (
      <a aria-label={title} href={completeUrl} onClick={itemClick}>
        {title}
      </a>
    );
  }
  return (
    <Link aria-label={title} href={completeUrl} target={target} callback={itemClick}>
      {title}
    </Link>
  );
};

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string,
  }),
  itemClick: func,
  dataTagCategory: string,
  target: string,
};

export { MenuItem };
